import { renderReactTooltip } from 'Cloud/ui/ReactTooltip';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { WebPushScreen } from 'reactApp/ui/WebPush/WebPushScreen';
import { renderModalDialog } from 'reactApp/utils/createDialogToolkit';

export const renderWebPushScreen = renderModalDialog(WebPushScreen, 'WebPushScreen');
export const renderWebPushTooltip = renderReactTooltip(popupNames.WEB_PUSH_TOOLTIP);
